
































































import { Component, Prop, Vue, Mixins, Ref } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import { SettingEntry } from "@/models/Setting";
import VNumericInput from "@/components/VNumericInput.vue";
import { httpStore } from "@/store/typed";
import WithErrors from "@/directives/WithErrors";

@Component({
  components: {
    VModal,
    VNumericInput,
  },
  directives: { WithErrors },
})
export default class EditGeneralSettingsCreateModal extends Vue {
  @Prop({ required: true })
  readonly type!: SettingEntry;
  @Prop({ required: true })
  readonly tag!: string;

  @Ref() readonly modal!: VModal;

  item = null;
  content = "";

  canceled!: Function | null;

  get isMeasurementUnit() {
    return "measurementUnits" === this.type.type;
  }

  get updateTag() {
    return this.tag.replace("$ID$", this.item?.id);
  }

  get updateRequest() {
    return httpStore.status[this.updateTag];
  }

  get loading() {
    return this.updateRequest?.loading;
  }

  get valid() {
    if (!this.item) {
      return false;
    }
    const baseValid = this.item.shortName && this.item.fullName;

    if (this.isCurrency) {
      return baseValid && this.item.symbol && this.item.conversion;
    } else {
      return baseValid;
    }
  }

  title() {
    return `Edit ${this.type.name.toLowerCase()}`;
  }

  get isCurrency() {
    return "currencies" === this.type.type;
  }

  hide() {
    this.modal.hide();
  }

  protected onCancel() {
    if (this.canceled) {
      this.canceled();
    }

    this.canceled = null;
    this.modal.hide();
  }

  protected onConfirm() {
    if (this.valid) {
      this.$emit("confirmed", this.item);
    }
  }

  protected onHidden() {
    if (this.canceled) {
      this.canceled();
    }
  }

  edit(item: any) {
    this.modal.show();
    this.item = { ...item };
  }
}
